import React, { useEffect, useState } from 'react';
// import Locales from 'UdeskLocales';
import { TreeSelect } from 'udesk-ui';
import { IntelligentPartnerTagGroupFoundResponse } from 'src/api/types';
import { getIntelligentPartnerTagGroups } from 'src/api/intelligentPartnerTagGroups';

// interface KnowledgeTreeSelectProps {
//     onChange: (value: any) => void;
//     value: Array<number>;
//     knowledgeCategoryIdsList: Array<number>;
// }

export const UserTagsSelect: React.FC<any> = (props) => {
    // const locales = Locales['current'];
    const { value, onChange, handleOriginalNodes, placeholder = '请选择', ...rest } = props;
    const [customerTagGroups, setCustomerTagGroups] = useState<
        IntelligentPartnerTagGroupFoundResponse[]
    >([]);
    const [, setLoading] = useState<boolean>(false);

    useEffect(() => {
        const originalNodes: IntelligentPartnerTagGroupFoundResponse[] = [];

        customerTagGroups.forEach((group) => {
            const selectedChildren = group.tags?.filter((child) => value?.includes(child.id!));
            if (selectedChildren && selectedChildren.length > 0) {
                originalNodes.push({
                    ...group,
                    tags: selectedChildren,
                });
            }
        });
        handleOriginalNodes?.(originalNodes);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [value, customerTagGroups]);

    const queryCustomerTagGroups = async () => {
        setLoading(true);
        try {
            const { data = [] } = await getIntelligentPartnerTagGroups();
            setCustomerTagGroups(
                data
                    .map((item) => {
                        return {
                            ...item,
                            title: item.groupName,
                            value: `group-${item.id}`,
                            children: item.tags?.map((tag) => {
                                return {
                                    ...tag,
                                    title: tag.tagName,
                                    value: tag.id,
                                };
                            }),
                        };
                    })
                    .filter((item) => item.tags && item.tags.length)
            );
            setLoading(false);
        } catch {
            setLoading(false);
        }
    };
    useEffect(() => {
        queryCustomerTagGroups();
    }, []);

    return (
        <TreeSelect
            value={value}
            treeData={customerTagGroups}
            treeCheckable={true}
            showCheckedStrategy={TreeSelect.SHOW_CHILD}
            placeholder={placeholder}
            multiple
            maxTagCount={3}
            showSearch
            allowClear
            showArrow
            onChange={onChange}
            {...rest}
        />
    );
};

